import { render } from "./InfiniteScrollObserver.vue?vue&type=template&id=005f9ccc"
import script from "./InfiniteScrollObserver.vue?vue&type=script&lang=ts"
export * from "./InfiniteScrollObserver.vue?vue&type=script&lang=ts"
script.render = render

export default script